var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-header" }, [
    _vm._m(0),
    _c("div", { staticClass: "container-header-menu" }, [
      _c(
        "div",
        { staticClass: "container-header-menu__overall" },
        _vm._l(_vm.menus, function (menu, index) {
          return _c(
            "div",
            {
              staticClass: "container-header-menu__item",
              on: {
                click: function ($event) {
                  return _vm.redirect(menu)
                },
              },
            },
            [
              _c("svg-icon", { attrs: { "icon-class": menu.icon } }),
              _vm._v(" " + _vm._s(menu.name) + " "),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "container-settings" }, [
      _c(
        "div",
        {
          staticClass: "container-settings_message",
          on: { click: _vm.handleMessage },
        },
        [_vm._v("消息")]
      ),
      _c(
        "div",
        {
          staticClass: "container-settings_help",
          on: { click: _vm.handleHelp },
        },
        [_vm._v("系统帮助")]
      ),
      _c(
        "div",
        {
          staticClass: "container-settings_user",
          on: { click: _vm.handleLogout },
        },
        [_vm._v("退出登录")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-header-title" }, [
      _c("img", { staticClass: "container-header-title__img" }),
      _c("span", { staticClass: "container-header-title__span" }, [
        _vm._v("江苏省农业农村厅数字工作平台"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }